import type { BoardScene, BoardShape } from "./board-schema";
import { clamp01 } from "./coords";

/** Rotate the tactical scene 180° while keeping labels readable and identities intact. */
export function flipBoard(scene: BoardScene): BoardScene {
  const flip = (value: number) => clamp01(1 - value);
  const shapes = scene.shapes.map((shape): BoardShape => {
    switch (shape.kind) {
      case "arrow":
      case "line":
        return {
          ...shape,
          x1: flip(shape.x1),
          y1: flip(shape.y1),
          x2: flip(shape.x2),
          y2: flip(shape.y2),
        };
      case "zone":
        return {
          ...shape,
          x: clamp01(1 - shape.x - shape.w),
          y: clamp01(1 - shape.y - shape.h),
        };
      case "label":
        return { ...shape, x: flip(shape.x), y: flip(shape.y) };
      case "freehand":
        return {
          ...shape,
          points: shape.points.map((p) => ({ x: flip(p.x), y: flip(p.y) })),
        };
    }
  });
  return {
    ...scene,
    shapes,
    tokens: scene.tokens.map((token) => ({
      ...token,
      x: flip(token.x),
      y: flip(token.y),
    })),
  };
}
